module.exports = [{"key":"grey","preview":"#b5b5b5","border":"0"},{"key":"dark","preview":"#6d6b6b","border":"0"},{"key":"white","preview":"white","border":"1px solid rgba(0, 0, 0, 0.1)"},{"key":"blue","preview":"rgb(156, 205, 216)","border":"0"},{"key":"green","preview":"rgb(174, 199, 187)","border":"0"},{"key":"pink","preview":"rgb(224, 195, 195)","border":"0"}]


//////////////////
// WEBPACK FOOTER
// ./client/components/Dummy/colors.json
// module id = 23
// module chunks = 0